import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from 'src/app/core/stores.service';
import { UtilsService } from 'src/app/core/utils.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-stores-qr-code-dialog',
  templateUrl: './stores-qr-code-dialog.component.html',
  styleUrls: ['./stores-qr-code-dialog.component.scss'],
})
export class StoresQrCodeDialogComponent {
  store?: Store;

  constructor(
    private dialog_ref: MatDialogRef<StoresQrCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private utils_service: UtilsService,
  ) {
    this.store = data.store;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onCopyClick(): void {
    const content: string = this.getQRCodeData();
    this.utils_service.copyClick(content);
  }

  onDownloadQRCodeClick(parent: any): void {
    const parent_element = parent.qrcElement.nativeElement.querySelector('canvas').toDataURL('image/png');
    if (parent_element) {
      const blob_data = this.convertBase64ToBlob(parent_element);
      const blob = new Blob([blob_data], { type: 'image/png' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'splittypay_qr_code';
      link.click();
    }
  }

  private convertBase64ToBlob(Base64Image: string): Blob {
    const parts = Base64Image.split(';base64,');
    const image_type = parts[0].split(':')[1];
    const decoded_data = window.atob(parts[1]);
    const u_int_8_array = new Uint8Array(decoded_data.length);
    for (let i = 0; i < decoded_data.length; ++i) {
      u_int_8_array[i] = decoded_data.charCodeAt(i);
    }
    return new Blob([u_int_8_array], { type: image_type });
  }

  getQRCodeData(): string {
    if (!this.store) return 'N/A';
    return this.utils_service.getBuyerAppLinkFromStore(this.store);
  }

  getStoreLogo(): string {
    return this.utils_service.getStoreLogo(this.store?.logo_url);
  }
}
